import { Alert, LinkButton } from "@vericus/cadmus-ui";

import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

import { DialoguePanel } from "@/features/socratic/components/dialogue-panel";
import {
  AnswerBlockFragment,
  SocraticDialogueFragment,
} from "@/generated/graphql";

import * as styles from "./socratic-dialogue.css";

interface Props {
  completedDialogue: SocraticDialogueFragment;
  answerBlock: AnswerBlockFragment;
  navigateToWork: () => void;
}

/**
 * Shown if the student refreshes on a completed Dialogue
 */
export function AlreadyCompletedScreen(props: Props) {
  const { completedDialogue, answerBlock, navigateToWork } = props;

  const { responseTimeSeconds } = completedDialogue;

  // TODO: Handle case where there are no turns
  const [firstTurn] = completedDialogue.turns;
  if (!firstTurn) return null;

  const submittedResponse = firstTurn.response;

  return (
    <PanelGroup direction="horizontal" className={styles.content}>
      <Panel
        id="recovery-dialogue-panel"
        order={1}
        defaultSize={34}
        minSize={20}
        maxSize={50}
      >
        <DialoguePanel
          answerBlock={answerBlock}
          turn={firstTurn}
          responseTimeSeconds={responseTimeSeconds}
        />
      </Panel>

      <PanelResizeHandle className={styles.handle} />

      <Panel id="recovery-main" order={2}>
        <div className={styles.main}>
          <div className={styles.webcamContainer()}>
            {submittedResponse?.mediaUrl != null && (
              <div className={styles.alreadyCompleted.videoContainer}>
                <video
                  src={submittedResponse.mediaUrl}
                  className={styles.alreadyCompleted.video}
                  controls
                  aria-label="Completed video"
                />
              </div>
            )}
          </div>
          <Alert
            severity="info"
            title="Already completed"
            className={styles.contentColumn}
          >
            This attempt has already been completed. Please{" "}
            <LinkButton kind="primary" onClick={navigateToWork}>
              return to the previous page
            </LinkButton>{" "}
            .
          </Alert>
        </div>
      </Panel>
    </PanelGroup>
  );
}
